import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/subcategoryCard.module.css';

import type { ISubcategoryCard } from './types';
import type { TBaseProps } from '@klv/shared/types';

const SubcategoryCard = ({
  articleCount,
  className,
  description,
  headlineVariant = 'p2',
  link,
  name,
  ...props
}: ISubcategoryCard & TBaseProps<'a'>) => {
  const { t } = useTranslation();

  if (articleCount && articleCount < 1) return null;

  return (
    <a href={link} className={generateClassName([className, s.card])} {...props}>
      <div className={generateClassName([headlineVariant, 'medium'])}>{name}</div>
      {!!description && <div className="p2">{description}</div>}
      {articleCount &&
        <div className="p2">
          {`${articleCount} ${articleCount > 1
            ? t('molecules_subcategoryCard_articlesPlural')
            : t('molecules_subcategoryCard_articleSingular')}`}
        </div>
      }
    </a>
  );
};

export default SubcategoryCard;
